var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarbonDashboardRgbRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dhl_icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44,27A20,20,0,1,0,7.305,38h33.39A19.8957,19.8957,0,0,0,44,27ZM10.0507,26h-2A15.9664,15.9664,0,0,1,34.8676,15.2808l-1.5019,1.3433A13.9634,13.9634,0,0,0,10.0507,26ZM28,29a4.0029,4.0029,0,1,1-1.7778-3.3246l9.9931-8.9215,1.3321,1.4922L27.5421,27.1785A3.9559,3.9559,0,0,1,28,29Z",
    fill: "#d70511"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonDashboardRgbRed);
export default __webpack_public_path__ + "static/media/carbon_dashboard_rgb_red.3365ec55141aa2dbc69b1489d7ca4784.svg";
export { ForwardRef as ReactComponent };